var pronouns = {
    male: "platform.fields.gender.option.male",
    female: "platform.fields.gender.option.female",
    they: "platform.fields.gender.option.other"
};
var genders = {
    male: "male",
    female: "female",
    they: "they"
};
export var genderOptions = [
    { name: genders.male, label: pronouns.male, value: "Male" },
    { name: genders.female, label: pronouns.female, value: "Female" },
    { name: genders.they, label: pronouns.they, value: "Unknown" }
];
export default [
    { gender: genders.male, pronoun: pronouns.male, initial: "M" },
    { gender: genders.female, pronoun: pronouns.female, initial: "F" },
    { gender: genders.they, pronoun: pronouns.they, initial: "N" }
];
export var defaultGender = { gender: genders.they, pronoun: pronouns.they, initial: "N" };
